import React from 'react'
import Axios from 'axios';

const   timeout     = 30000;
var     host        = "https://cosmed-verif.cosmetic-safety.eu/index.php/wp-json/verif-inci/v1/";

var requests_store = {};

const request  = (config, url, params) => {
    
    if(!config.hasOwnProperty("headers")){
        
        config.headers = {};
    }   
        
    let connection = {
        
        method:     config.method,
        url:        host + url,
        data:       params,
        headers:    config.headers,  
        timeout:    timeout 
    };
    
    // Axios related: GET requests ignore the property "data". The parameters
    // must appear into the property "params" so they are encoded and added to 
    // the URL.
    if(connection.method === "get"){
        
        connection.params = params;
    }
    
    
    return Axios(connection);
};


const getHeaders = (method) => {
    
    let res = {method:method, headers:{}};
  
    return res;
};


export default {        
             
    getHost: () =>{
        
        return host;
    },
    setHost: (new_host) => {
     
        host = new_host;
    },            
    
        
    get: (url, params, callback_then, callback_catch) => { 

        return request(getHeaders("get"), url, params, callback_then, callback_catch);
    },


    post: (url, params, callback_then, callback_catch) => {         
      
        return request(getHeaders("post"), url, params, callback_then, callback_catch);            
    },
    
    
    getError: (error_message) => {
        
        let list = {
            
            branch_title_is_empty: "The branch title is missing"
        };
        
        let clean = error_message.replace(/_/g, " ");
        
        return list[error_message] || clean; 
    }
};